import { useQuery } from '@tanstack/react-query';

import getBrand from 'Api/brand/getBrand';

import getBrandResponse from './model/response/getBrandResponse';

const useGetBrand = () => {
  return useQuery({
    queryKey: ['all-brand'],
    queryFn: async () => {
      const response = await getBrand();

      const result = getBrandResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetBrand;
